/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".force-log-out-modal__body[_ngcontent-%COMP%]{font-size:1rem;margin-bottom:2rem;white-space:pre-line}.force-log-out-modal__countdown[_ngcontent-%COMP%]{font-size:2.5rem;font-weight:700;margin-bottom:0;text-align:center}"];
export { styles as styles };
//# sourceMappingURL=force-log-out-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/exams/end-of-level-exam/force-log-out-modal/force-log-out-modal.component.scss.shim.ngstyle.js
// module id = 1393
// module chunks = 27 28 29